import { TimeZoneEnum } from '@zaoblako/shared/common/enums/time.zone.enum';

/** Function which returns current time zone for backend or frontend application */
export type TimeZoneExtractor = () => TimeZoneEnum;

/** Provides isomorphic facade for current time zone extraction. Singleton object. */
export class CurrentTimeZoneExtractorClass {
  private static instance: CurrentTimeZoneExtractorClass = null;

  public static getInstance(): CurrentTimeZoneExtractorClass {
    if (!CurrentTimeZoneExtractorClass.instance) {
      CurrentTimeZoneExtractorClass.instance = new CurrentTimeZoneExtractorClass();
    }
    return CurrentTimeZoneExtractorClass.instance;
  }

  private extractor: TimeZoneExtractor;

  private constructor() {
    this.extractor = (): TimeZoneEnum => TimeZoneEnum.EUROPE_MOSCOW;
  }

  /** Extract current time zone */
  public getCurrentTimeZone(): TimeZoneEnum {
    return this.extractor();
  }

  /** Set current time zone extractor */
  public setExtractor(extractor: TimeZoneExtractor): void {
    this.extractor = extractor;
  }
}
